export default "__VITE_ASSET__fc215415__"